import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import AboutSection from './components/AboutSection';
import StatsSection from './components/StatsSection';
import FeaturedSection from './components/FeaturedSection';
import TailoringSection from './components/TailoringSection';
import ContactBar from './components/ContactBar';

const HomePage = () => {
  return (
    <div className="min-h-screen">
      <Navbar />
      <HeroSection />
      <ContactBar />
      <FeaturedSection />
      <TailoringSection />
      <AboutSection />
      <StatsSection />
      <Footer />
    </div>
  );
};

export default HomePage;
